var coinPrecisions = {
    USDT: 2,
    USDC: 2,
    BTC: 8,
};

export { coinPrecisions };
